import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RootLayout } from "./components/layout/layout";
import {
  AboutPage,
  AddCardForm,
  AmlPage,
  AmlResultPage,
  BankCardsPage,
  FAQPage,
  Home,
  PaymentForm,
  PersonalDataForm,
  ProfilePage,
  ReferralPage,
  ServicePaymentPage,
  SuccessPaymentPage,
  TransactionHistoryPage,
  WithdrawlPage,
  ForeignCardChoosePage,
  ForeignCardApplyFormPage,
  MaintenancePage,
  ExchangePage,
  DepositPage,
  WithdrawPage,
  CardsPage,
  CardsIssuePage,
  CardDetailPage,
  TransactionDetailPage,
  PayQrPage,
  PayQrPendingPage,
  AssetDetailPage,
  ReferralRewardsPage,
  SessionsPage,
  P2pPage,
} from "./pages";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "/profile", element: <ProfilePage /> },
        { path: "/payment", element: <PaymentForm /> },
        { path: "/history", element: <TransactionHistoryPage /> },
        { path: "/history/:orderId", element: <TransactionDetailPage /> },
        { path: "/pay-qr", element: <PayQrPage /> },
        { path: "/pay-qr/:paymentId", element: <PayQrPendingPage /> },
        { path: "/personal-data", element: <PersonalDataForm /> },
        { path: "/bank-cards", element: <BankCardsPage /> },
        { path: "/add-card", element: <AddCardForm /> },
        { path: "/about", element: <AboutPage /> },
        { path: "/faq", element: <FAQPage /> },
        { path: "/referral", element: <ReferralPage /> },
        { path: "/referral/rewards", element: <ReferralRewardsPage /> },
        { path: "/aml", element: <AmlPage /> },
        { path: "/withdrawl", element: <WithdrawlPage /> },
        { path: "/aml-result", element: <AmlResultPage /> },
        { path: "/service-payment", element: <ServicePaymentPage /> },
        { path: "/success-payment", element: <SuccessPaymentPage /> },
        { path: "/foreign-card", element: <ForeignCardChoosePage /> },
        { path: "/foreign-card/apply", element: <ForeignCardApplyFormPage /> },
        { path: "/maintenance", element: <MaintenancePage /> },
        { path: "/exchange", element: <ExchangePage /> },
        { path: "/deposit", element: <DepositPage /> },
        { path: "/withdraw", element: <WithdrawPage /> },
        { path: "/cards", element: <CardsPage /> },
        { path: "/cards/issue", element: <CardsIssuePage /> },
        { path: "/cards/:cardId", element: <CardDetailPage /> },
        { path: "/asset/:code", element: <AssetDetailPage /> },
        { path: "/sessions", element: <SessionsPage /> },
        { path: "/p2p", element: <P2pPage /> },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
